import { Skeleton } from '@mui/material';
import React from 'react';

export const StyChipLoading = () => (
    <Skeleton
        variant="rounded"
        height={26}
        width={136}
        sx={{ borderRadius: '26px' }}
    />
);
